import React from "react";
import { ArrowRight, Bell } from "lucide-react";
import { CONTROL_ALERT_MOCK } from "./controlContent";

const ControlAlertMock = () => (
  <div
    className="relative w-full max-w-[300px] mx-auto lg:mx-0"
    data-testid="control-alert-mock"
  >
    <div className="absolute -inset-3 bg-gradient-to-br from-orange-500/10 to-transparent rounded-2xl blur-xl pointer-events-none" />

    <div className="relative rounded-2xl border border-white/10 bg-[#0c1018] shadow-2xl shadow-black/40 overflow-hidden">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-white/[0.06] bg-white/[0.02]">
        <div className="relative">
          <Bell className="w-4 h-4 text-orange-400" aria-hidden="true" />
          <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-orange-500" />
        </div>
        <span className="text-xs font-semibold text-white">{CONTROL_ALERT_MOCK.title}</span>
        <span className="ml-auto text-[9px] font-mono text-gray-600">LIVE</span>
      </div>

      <div className="p-4 space-y-3">
        {CONTROL_ALERT_MOCK.items.map((item) => (
          <div
            key={item.tag}
            className="rounded-lg border border-white/[0.06] bg-white/[0.02] px-3 py-2.5"
          >
            <span className="badge-mono text-[9px] text-orange-400/90 tracking-wider">{item.tag}</span>
            <p className="text-[11px] text-gray-300 font-body mt-1 leading-snug">{item.text}</p>
          </div>
        ))}
      </div>

      <div className="px-4 pb-4">
        <div className="flex items-center justify-center gap-2 w-full py-2.5 rounded-lg bg-orange-500/15 border border-orange-500/25 text-orange-300 text-[11px] font-semibold">
          {CONTROL_ALERT_MOCK.cta}
          <ArrowRight className="w-3.5 h-3.5" aria-hidden="true" />
        </div>
      </div>
    </div>
  </div>
);

export default ControlAlertMock;
